/* eslint-disable max-lines */
import {
  PLATFORMS_DISPLAY_MAP,
  FILM_PLATFORM,
  SEASON_PLATFORM,
  YOUTUBE_PLATFORM,
  INSTAGRAM_PLATFORM,
  FACEBOOK_PLATFORM,
  TWITTER_PLATFORM,
  TWITCH_PLATFORM,
  TIKTOK_PLATFORM,
  OTHER_PLATFORM,
  VIDEO_MEDIA_TYPE,
  REELS_MEDIA_TYPE,
  LIVE_MEDIA_TYPE,
  STORY_MEDIA_TYPE,
  STREAM_MEDIA_TYPE,
  POST_MEDIA_TYPE,
  PHOTO_MEDIA_TYPE,
  EPISODE_MEDIA_TYPE,
  FILM_MEDIA_TYPE,
  PRODUCTION_MEDIA_TYPE,
  INTEGRATION_STYLE,
  THEMATIC_STYLE,
  DEDICATED_STYLE,
  TRADITIONAL_MEDIA_TARGETS,
  INFLUENCER_MEDIA_TARGETS,
  METRICS_PER_MEDIA_TYPE,
} from 'shared/metrics/metrics';
import { DEMOGRAPHIC_METRICS } from './demographicMetrics';

export const MEDIA_TYPES_DISPLAY_MAP = {
  [EPISODE_MEDIA_TYPE]: 'Episode',
  [VIDEO_MEDIA_TYPE]: 'Video',
  [STORY_MEDIA_TYPE]: 'Story',
  [POST_MEDIA_TYPE]: 'Post',
  [STREAM_MEDIA_TYPE]: 'Stream',
  [FILM_MEDIA_TYPE]: 'Film',
  [PHOTO_MEDIA_TYPE]: 'Photo',
  [REELS_MEDIA_TYPE]: 'Reels',
  [LIVE_MEDIA_TYPE]: 'Live',
  [PRODUCTION_MEDIA_TYPE]: 'Production',
};

export const PLATFORMS_SELECT_OPTIONS = Object.keys(PLATFORMS_DISPLAY_MAP).map(
  (platform) => ({
    value: platform,
    label: PLATFORMS_DISPLAY_MAP[platform],
  }),
);

export const PLATFORMS_MEDIA_TYPES = {
  [FILM_PLATFORM]: [FILM_MEDIA_TYPE],
  [SEASON_PLATFORM]: [EPISODE_MEDIA_TYPE],
  [YOUTUBE_PLATFORM]: [VIDEO_MEDIA_TYPE, STREAM_MEDIA_TYPE],
  [INSTAGRAM_PLATFORM]: [
    VIDEO_MEDIA_TYPE,
    STORY_MEDIA_TYPE,
    PHOTO_MEDIA_TYPE,
    REELS_MEDIA_TYPE,
    LIVE_MEDIA_TYPE,
  ],
  [FACEBOOK_PLATFORM]: [VIDEO_MEDIA_TYPE, POST_MEDIA_TYPE, LIVE_MEDIA_TYPE],
  [TWITTER_PLATFORM]: [VIDEO_MEDIA_TYPE, POST_MEDIA_TYPE],
  [TWITCH_PLATFORM]: [STREAM_MEDIA_TYPE],
  [TIKTOK_PLATFORM]: [VIDEO_MEDIA_TYPE],
  [OTHER_PLATFORM]: [
    VIDEO_MEDIA_TYPE,
    STORY_MEDIA_TYPE,
    STREAM_MEDIA_TYPE,
    POST_MEDIA_TYPE,
    PHOTO_MEDIA_TYPE,
  ],
};

const STYLES_DISPLAY_MAP = {
  [INTEGRATION_STYLE]: 'Integration',
  [THEMATIC_STYLE]: 'Thematic',
  [DEDICATED_STYLE]: 'Dedicated',
};

export const STYLES_SELECT_OPTIONS = Object.keys(STYLES_DISPLAY_MAP).map(
  (style) => ({
    value: style,
    label: STYLES_DISPLAY_MAP[style],
  }),
);

const getMediaConfig = (mediaTargetsByPlatform) =>
  Object.entries(mediaTargetsByPlatform).reduce(
    (acc, [platform, mediaTargets]) => {
      mediaTargets.forEach(({ mediaType, style }) => {
        acc.push({
          mediaType,
          style,
          platform,
        });
      });
      return acc;
    },
    [],
  );

const getMetricConfig = (mediaTargetsByPlatform) => {
  const result = Object.entries(mediaTargetsByPlatform).reduce(
    (acc, [platform, mediaTargets]) => {
      mediaTargets.forEach(({ mediaType, kpi, defaultKpi }) => {
        acc.set(`${platform}-${mediaType}-${kpi}`, {
          mediaType,
          metricType: kpi ?? defaultKpi,
          platform,
        });
      });
      return acc;
    },
    new Map(),
  );
  return [...result.values()];
};
export const TRADITIONAL_MEDIA_CONFIG = getMediaConfig(
  TRADITIONAL_MEDIA_TARGETS,
);

export const INFLUENCER_METRIC_CONFIG = getMetricConfig(
  INFLUENCER_MEDIA_TARGETS,
);
export const TRADITIONAL_METRIC_CONFIG = getMetricConfig(
  TRADITIONAL_MEDIA_TARGETS,
);

export const METRICS_PER_MEDIA_TYPE_WITH_DEMOGRAPHICS = {
  [POST_MEDIA_TYPE]: [
    ...METRICS_PER_MEDIA_TYPE[POST_MEDIA_TYPE],
    ...DEMOGRAPHIC_METRICS,
  ],
  [PHOTO_MEDIA_TYPE]: [
    ...METRICS_PER_MEDIA_TYPE[PHOTO_MEDIA_TYPE],
    ...DEMOGRAPHIC_METRICS,
  ],
  [VIDEO_MEDIA_TYPE]: [
    ...METRICS_PER_MEDIA_TYPE[VIDEO_MEDIA_TYPE],
    ...DEMOGRAPHIC_METRICS,
  ],
  [STORY_MEDIA_TYPE]: [
    ...METRICS_PER_MEDIA_TYPE[STORY_MEDIA_TYPE],
    ...DEMOGRAPHIC_METRICS,
  ],
  [STREAM_MEDIA_TYPE]: [
    ...METRICS_PER_MEDIA_TYPE[STREAM_MEDIA_TYPE],
    ...DEMOGRAPHIC_METRICS,
  ],
  [REELS_MEDIA_TYPE]: [
    ...METRICS_PER_MEDIA_TYPE[REELS_MEDIA_TYPE],
    ...DEMOGRAPHIC_METRICS,
  ],
  [LIVE_MEDIA_TYPE]: [
    ...METRICS_PER_MEDIA_TYPE[LIVE_MEDIA_TYPE],
    ...DEMOGRAPHIC_METRICS,
  ],
};
